import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent {

  @Output()
  valueChange = new EventEmitter<any>();

  @Input()
  selectValue: any;

  @Input()
  label: string;

  @Input()
  data: any[] = [];

  @Input()
  textField: any;

  @Input()
  valueField: string;

  @Input()
  descrptionField: string;

  @Input()
  optionStyle: string;

  onOptionSelect(option: any) {
    this.selectValue = option.value;
    this.valueChange.emit(option);
  }
}
